import { render, staticRenderFns } from "./DasherRanks.vue?vue&type=template&id=4853570a&scoped=true"
import script from "./DasherRanks.vue?vue&type=script&lang=js"
export * from "./DasherRanks.vue?vue&type=script&lang=js"
import style0 from "./DasherRanks.vue?vue&type=style&index=0&id=4853570a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853570a",
  null
  
)

export default component.exports